import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileLines } from '@fortawesome/pro-solid-svg-icons';
import { Button } from '@quero-delivery/quero-components-web';
import { useRef, useState } from 'react';
import styles from './row-send-file.module.scss';
import { ModalShowDoc } from '@/_features/motoboys/approval-mat/components/modal-show-doc';
import type { ENUM_FILE_NAME } from '../../types';

interface RowSendFileProps {
  title: string;
  fileName: ENUM_FILE_NAME;
  image?: string;
  isLoadingButton: boolean;
  onSave: ({
    file,
    fileName,
  }: {
    file: File;
    fileName: ENUM_FILE_NAME;
  }) => void;
}

function RowSendFile({
  title,
  fileName,
  image,
  isLoadingButton,
  onSave,
}: RowSendFileProps) {
  const [showModal, setShowModal] = useState(false);

  const donwloadPdf = (imageUrl: string) => {
    window.open(imageUrl, '_blank');
  };

  const handleClickViewDocument = (document: string) => {
    if (!document) return;
    const isPdf = document?.toLowerCase()?.includes('pdf');

    if (isPdf && !Array.isArray(document)) {
      donwloadPdf(document);
    } else {
      setShowModal(true);
    }
  };

  const fileRef = useRef<HTMLInputElement | null>(null);

  return (
    <div className={styles.rowContainer}>
      <div className={styles.docsWrapper}>
        <FontAwesomeIcon icon={faFileLines} className={styles.iconDocument} />
        <span className={styles.spanDocument}>{title}</span>
      </div>

      <div className={styles.buttonsWrapper}>
        {image ? (
          <Button
            textFirst="Visualizar documento"
            noBorder
            type="button"
            width="100%"
            test-id="button-view-document"
            className={styles.buttonViewDocument}
            onClick={() => {
              handleClickViewDocument(image);
            }}
          />
        ) : null}

        <div>
          <input
            hidden
            id="input-file"
            data-testid="input-file"
            type="file"
            accept="image/png,image/jpeg,image/jpg,application/pdf"
            onChange={e => {
              const { files } = e.target;

              if (!files) return;

              onSave({
                file: files[0],
                fileName,
              });

              fileRef.current!.value = '';
            }}
            ref={fileRef}
          />
          <Button
            width="100%"
            className={styles.buttonAttachDocument}
            loading={isLoadingButton}
            textFirst="Adicionar"
            onClick={() => fileRef.current?.click()}
            type="button"
          />
        </div>
      </div>

      {showModal && (
        <ModalShowDoc
          title={title}
          imageUrl={image || []}
          open={showModal}
          onClose={() => setShowModal(false)}
        />
      )}
    </div>
  );
}

export { RowSendFile };
